exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chat_envelope__unread[data-v-0d82eae0]{font-weight:700}.chat_envelope__pointer[data-v-0d82eae0]{cursor:pointer}.chat_envelope__pulse[data-v-0d82eae0]{width:44px;height:44px;animation:chat_envelope_animscale-data-v-0d82eae0 .3s ease-in-out alternate}.chat__envelope-attendee[data-v-0d82eae0]{margin-bottom:2px}.chat_notifications_label[data-v-0d82eae0]{font-size:14px;line-height:25px;margin-right:1rem}.chat_envelope__hide_list[data-v-0d82eae0]{display:none}@keyframes chat_envelope_animscale-data-v-0d82eae0{0%{transform:scale(1)}to{transform:scale(1.2)}}", ""]);

// exports
